
export class ErrorHandler {
    public static HandleError(xhr: any, isAuthenticated = true) {

        if (xhr.responseJSON && xhr.responseJSON.IsJsonResponse) {
            console.log("Error loading question fields: " + xhr.status + ": " + xhr.responseJSON.Message);
            //Possible session timeout
            if (xhr.responseJSON.RedirectUrl) {
                window.location.href = xhr.responseJSON.RedirectUrl
            }
        }

        if (xhr.status == 0) {
            //Ignore.User navigating away from page.
        }
        else if (xhr.status == 401 || xhr.status == 440) {
            if (isAuthenticated) {
                window.location.href = `${window.location.origin}/Home/SessionTimeout`;
            } else {
                window.location.href = `${window.location.origin}/Home/ApplicationTimeout`;
            }
        }
        else if (xhr.status == 400) {
            console.log("Error Text: " + xhr.responseText);
            console.log("Error: " + xhr.statusText);
            console.log("Status: " + xhr.status);
            console.log("Status Code: " + xhr.statusCode);

            //bad call. Log with AI.
            var errObj: Error = new Error("RebateCalc Error (400)");
            //FIXME: Log with AI
            //window.appInsights.trackException({ exception: errObj, properties: { "FormData": formJson, "XHR_Response": xhr.responseText } });
            window.location.href = `${window.location.origin}/Home/Error`;
        } else {
            console.log("Error Text: " + xhr.responseText);
            console.log("Error: " + xhr.statusText);
            console.log("Status: " + xhr.status);
            console.log("Status Code: " + xhr.statusCode);
            if (!isAuthenticated) {
                //Send unauthenticated users to the application timeout page.
                window.location.href = `${window.location.origin}/Home/ApplicationTimeout`;
            } else {
                window.location.href = `${window.location.origin}/Home/Error`;
            }
            
        }

    }
}